import { useFormik } from 'formik';
import { Submotive2DataProps } from './props';
import { useEffect } from 'react';
import { ISelect } from '../../../../../../shared/types/shared';

export const useSubmotive2Data = ({ data }: Submotive2DataProps) => {
    const formik = useFormik({
        initialValues: {
            name: '',
            active: false,
            extra2: '',
            parent: '',
            nestedParent: '',
            nestedParent2: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        formik?.setFieldValue('name', data?.name || '');
        formik?.setFieldValue('active', data?.active || false);
        formik?.setFieldValue('extra2', data?.extra2 || '');
        formik?.setFieldValue('parent', (data?.parent as ISelect)?.name || '');
        formik?.setFieldValue(
            'nestedParent',
            ((data?.parent as ISelect)?.parent as ISelect)?.name || ''
        );
        formik?.setFieldValue(
            'nestedParent2',
            (((data?.parent as ISelect)?.parent as ISelect)?.parent as ISelect)
                ?.name || ''
        );
    }, [data]);

    return {
        formik,
    };
};
